import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setMatScenes: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.loading = !!payload.loading;
};

// 新增弹窗
export const setAddDialog: Mutation<IModuleState> = (state, payload) => {
  state.addDialog.data = payload.data || null;
  state.addDialog.title = payload.title || '';
  state.addDialog.visible = !!payload.visible;
  state.addDialog.loading = !!payload.loading;
};

// 编辑弹窗
export const setEditDialog: Mutation<IModuleState> = (state, payload) => {
  state.editDialog.data = payload.data || null;
  state.editDialog.title = payload.title || '';
  state.editDialog.visible = !!payload.visible;
  state.editDialog.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
